import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '../store'

const DEFAULT_TIMEOUT = 2500

type AlertState = {
  consentVisible: boolean
  success: any // Can be string, element, or any.
  successAutoHideDuration: number
  error: any // Can be string, element or any.
  errorAutoHideDuration: number
}

const initialState: AlertState = {
  consentVisible: false,
  success: null,
  successAutoHideDuration: DEFAULT_TIMEOUT,
  error: null,
  errorAutoHideDuration: DEFAULT_TIMEOUT
}

//Slice for global alerts, more can be added in here
export const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    toggleConsent: (state: AlertState, action: PayloadAction<boolean>) => {
      state.consentVisible = action.payload
    },
    addSuccess: (state: AlertState, action: PayloadAction<any>) => {
      state.success = action.payload.msg
      state.successAutoHideDuration = action.payload.timeout
    },
    addError: (state: AlertState, action: PayloadAction<any>) => {
      state.error = action.payload.msg
      state.errorAutoHideDuration = action.payload.timeout
    },
    clearSuccess: (state: AlertState) => {
      state.success = null
    },
    clearError: (state: AlertState) => {
      state.error = null
    }
  }
})

export const {
  toggleConsent,
  addSuccess,
  addError,
  clearSuccess,
  clearError
} = alertSlice.actions

export default alertSlice.reducer

export const selectAlert = (state: RootState) => state.alert

export const AddSuccessAlert = (msg, timeout = DEFAULT_TIMEOUT) => {
  return async (dispatch: AppDispatch) => {
    dispatch(addSuccess({ msg, timeout }))
    setTimeout(() => {
      dispatch(clearSuccess())
    }, timeout)
  }
}

export const AddErrorAlert = (msg, timeout = DEFAULT_TIMEOUT) => {
  return async (dispatch: AppDispatch) => {
    dispatch(addError({ msg, timeout }))
    setTimeout(() => {
      dispatch(clearError())
    }, timeout)
  }
}
